import * as excelService from "xlsx-js-style";

export type ExcelRow = Record<string, string | number | boolean | null>;

const headerCellStyle = {
  font: { bold: true },
  fill: { patternType: "solid", fgColor: { rgb: "D9D9D9" } },
  alignment: { vertical: "center" },
};

export const exportToExcel = (
  rows: ExcelRow[],
  headers: string[],
  fileName: string,
  sheetName: string
) => {
  const worksheet = excelService.utils.json_to_sheet(rows, { header: headers });
  worksheet["!cols"] = headers.map((header) => ({
    wch:
      Math.max(
        header.length,
        ...rows.map((row) => String(row[header] ?? "").length)
      ) + 2,
  }));

  headers.forEach((_, columnIndex) => {
    const headerCell =
      worksheet[excelService.utils.encode_cell({ r: 0, c: columnIndex })];

    if (headerCell) {
      headerCell.s = headerCellStyle;
    }
  });

  const workbook = excelService.utils.book_new();
  excelService.utils.book_append_sheet(workbook, worksheet, sheetName);
  excelService.writeFile(workbook, `${fileName}.xlsx`);
};
